<template>
  <div class="mb-3">
    <b-form-group :class="title_position" :label-cols-lg="labels_lg" id="example text" :label="FormDataType.FieldTitle"
      label-for="text">
 
<multiselect
  :multiple="true"
  v-model="selectedObjects"
  :options="FormDataType.ComboDataArray"
  track-by="id"
  :custom-label="o => o?.label ? String(o.label) : ''"
  placeholder="Lütfen seçim yapınız"
  :searchable="true"
  :key="FormDataType.ComboDataArray?.length"
/>


      <template v-if="v.$error">
        <div v-for="(error, index) of v.$silentErrors" :key="index">
          <div>
            <span v-if="error.$validator == 'required'">{{
              $t("ValidationMessage.required")
            }}</span>
            <span v-else>{{ error.$message }}</span>
          </div>
        </div>
      </template>
    </b-form-group>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<script>
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },

  props: {
    v: Object,
    FormDataType: Object,
    Value: Array, // 👉 SADECE id dizisi gelecek
    title_position: String,
    labels_lg: Number,
  },
methods: {
  customLabel(option) {
    return option?.label ? String(option.label) : ''
  }
},
  computed: {
    // Multiselect'in göreceği NESNE dizisi
    selectedObjects: {
      get() {
        if (!this.Value || !this.FormDataType?.ComboDataArray) return []

        // id → nesne eşlemesi
        return this.FormDataType.ComboDataArray.filter(item =>
          this.Value.includes(item.id)
        )
      },
      set(val) {
        // nesne → sadece id
        const ids = val.map(x => x.id)
        this.$emit('input', ids)
      }
    }
  }
}
</script>
